import posthog from "posthog-js";

const POSTHOG_KEY =
  import.meta.env.VITE_POSTHOG_KEY ?? "phc_Tn7VwYeF9rBKXaQSPwMd38ivoKB2r13tJYkOYWRkrMJ";
const POSTHOG_HOST = import.meta.env.VITE_POSTHOG_HOST ?? "https://eu.posthog.com";

let initialized = false;

export function initPostHog(): void {
  if (typeof window === "undefined") return;
  if (initialized) return;

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    person_profiles: "identified_only",
    session_recording: {
      maskAllInputs: true,
      maskInputOptions: {
        password: true,
        email: false,
      },
    },
    capture_pageview: true,
    capture_pageleave: true,
    capture_exceptions: true,
    autocapture: {
      dom_event_allowlist: ["click", "submit", "change"],
    },
    loaded: () => {
      if (import.meta.env.DEV) {
        // eslint-disable-next-line no-console
        console.debug("[PostHog] loaded");
      }
    },
  });

  initialized = true;
}

export { posthog };
